@if (actionCount > 0) {
  <div class="bg-white rounded-3xl shadow-sm p-4">
    <div class="mb-3">
      <h3 class="text-base font-semibold text-[#023E42]">
        🌱 {{ 'home.today.title' | translate }}
      </h3>
      <p class="text-xs text-[#9BA5A1]">
        {{ 'home.today.count' | translate: { count: actionCount } }}
      </p>
    </div>

    <div class="flex flex-col gap-2">
      <!-- Les récoltes en tête : la fenêtre est ouverte, le geste ne se
           discute pas, et c'est ce qui donne envie de sortir. -->
      @for (harvest of harvests; track harvest.plantUid) {
        <button type="button" (click)="openGarden()"
          class="w-full flex items-center gap-3 rounded-2xl border border-[#F0E2C8] bg-[#FFFBF2] p-3 text-left">
          @if (harvest.imageUrl) {
            <img [src]="harvest.imageUrl" [alt]="harvest.name"
              class="w-11 h-11 rounded-xl object-cover shrink-0">
          } @else {
            <div class="w-11 h-11 rounded-xl flex items-center justify-center bg-[#FDF3E3] text-xl shrink-0">🧺</div>
          }
          <span class="flex-1 min-w-0">
            <span class="block truncate text-[15px] font-semibold text-[#023E42]">
              {{ 'home.today.harvest' | translate: { plant: harvest.name } }}
            </span>
            <!-- L'endroit plutôt qu'un rappel de maturité : « récolte ton
                 persil » laisse chercher dans tout le jardin. -->
            <span class="block truncate text-xs text-[#8A5A12]">
              <span class="mr-1">🧺</span>@if (harvest.locationName) {
                {{ harvest.locationName | locationLabel }}
              } @else {
                {{ 'home.today.harvest-ready' | translate }}
              }
            </span>
          </span>
          <svg viewBox="0 0 24 24" class="h-[18px] w-[18px] shrink-0 text-[#C8A96A]" fill="none" aria-hidden="true">
            <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      }

      <!-- Une ligne = un geste. Le verbe vient du DÉCLENCHEUR, calculé par le
           serveur, jamais du texte du modèle : « forte chaleur » implique
           d'arroser, « gel » de protéger, et ces associations-là ne peuvent
           pas contredire le conseil qu'elles coiffent. Le paragraphe du
           modèle se déroule au toucher, pour qui veut le détail. -->
      @for (card of cards; track card.plantUid + card.trigger) {
        <button type="button" (click)="toggle(card)"
          class="w-full flex gap-3 rounded-2xl border border-[#E6EEE9] bg-[#FBFDFC] p-3 text-left"
          [class.items-center]="!isExpanded(card)"
          [class.items-start]="isExpanded(card)">
          @if (card.imageUrl) {
            <img [src]="card.imageUrl" [alt]="card.plantName"
              class="w-11 h-11 rounded-xl object-cover shrink-0">
          } @else {
            <div class="w-11 h-11 rounded-xl flex items-center justify-center text-xl shrink-0"
              [style.background-color]="chipStyle(card.trigger).background">
              {{ chipStyle(card.trigger).emoji }}
            </div>
          }

          <span class="flex-1 min-w-0">
            <span class="block truncate text-[15px] font-semibold text-[#023E42]">
              {{ 'home.today.action.' + card.trigger | translate: { plant: card.plantName } }}
            </span>
            <span class="block truncate text-xs text-[#6E7B75]">
              <span class="mr-1">{{ chipStyle(card.trigger).emoji }}</span>{{ 'home.garden-today.triggers.' + card.trigger | translate: triggerOf(card.trigger) }}
            </span>

            <!-- Le conseil rédigé, déroulé à la demande. -->
            @if (isExpanded(card)) {
              <span class="mt-2 block text-xs leading-relaxed text-[#3c4a45]">{{ card.text }}</span>
              @if (card.stepName) {
                <span class="mt-1 inline-block rounded-full bg-grey-100 px-2 py-0.5 text-[10px] text-grey-600">
                  {{ card.stepName }}
                </span>
              }
            }
          </span>

          <svg viewBox="0 0 24 24" class="h-[18px] w-[18px] shrink-0 self-center text-[#9BA5A1] transition-transform"
            [class.rotate-90]="isExpanded(card)" fill="none" aria-hidden="true">
            <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      }
    </div>

    <button type="button" (click)="askWilly()"
      class="w-full mt-3 flex items-center justify-center gap-2 bg-[#DAF2E0] active:bg-[#C3E5CE] transition-colors rounded-2xl py-2.5">
      <img src="/assets/images/willy/willy_hi.png" alt="Willy" class="w-7 h-7 object-contain">
      <span class="text-[13px] font-semibold text-[#023E42]">{{ 'home.garden-today.ask-willy' | translate }}</span>
    </button>
  </div>
}
